module.exports = __webpack_public_path__ + "img/ws-logo-full.55fcfe7a.svg";